import SafeImage from '@ui/SafeImage';
import { getCDNUrl } from '@util/index';
import { ProductDocument } from '@models/product';
import Link from 'next/link';
import { getProductSlug } from '@util/urlHelpers';

const SellingProductCard = ({ product }: { product: ProductDocument }) => (
  <Link
    href={getProductSlug(product)}
    className="flex  min-w-[19.4rem] flex-col overflow-hidden rounded-brand  bg-white shadow-md"
  >
    <ProductPicture product={product} />
  </Link>
);

const SoldOutOverlay = () => (
  <div className="absolute inset-0 mx-auto flex h-[5rem] items-center justify-center">
    <span className="absolute z-10 rounded-[20rem] bg-brand-secondary px-[2.4rem] py-[0.4rem]  text-[1.8rem]  font-semibold tracking-wider text-white">
      Sold
    </span>
  </div>
);

const ProductPicture = ({ product }: { product: ProductDocument }) => {
  return (
    <div className="relative h-[18rem] w-[19.4rem] shrink-0 overflow-clip bg-brand-black">
      <SafeImage
        alt={product.title}
        src={getCDNUrl(product.thumbnail)}
        fill
        classes={`transition-transform duration-200 delay-0 ease-in-out group-hover:scale-105  opacity-50 ${
          product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12'
            ? 'object-contain'
            : 'object-cover'
        }`}
      />

      {product.out_of_stock && <SoldOutOverlay />}
    </div>
  );
};

export default SellingProductCard;
